import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { ProjectErrorType } from './projectErrorApiTypes';

export const getProjectErrors = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<ProjectErrorType>>(config, `/projectError`, 'GET', null, commonHeaders);

export const deleteProjectError = async (config: LoruleRequestConfig, errorId: number) =>
    callWebUtils(config, `/projectError/${errorId}`, 'DELETE', null, commonHeaders);

export const syncProject = async (
    config: LoruleRequestConfig,
    amId: number,
    user: boolean = true,
) => callWebUtils(config, `/projectError/${amId}?user=${user}`, 'PATCH', null, commonHeaders);
